/*
 * Public API Surface of uuid
 */

export * from './lib/generate-uuid';
export * from './lib/extract-uuid';
export * from './lib/uuids-equal';
